export default "<div id=\"app-loader-preloader\">\n    <div class=\"loader-img\"></div>\n</div>";